export default __webpack_public_path__ + "static/assets/med_gel_solid_02_b.c6377d7d.png";